/*
* @requires  monitor-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function Monitor(param) {
        this.imp=new $m.MonitorWebsocket(param,this,null);
        //this.imp.setEventCallback(this,null);
        //this.imp.setEventCallback(this,this._eventHandler);
    }

    Monitor.prototype.getVersion=function (param){
        return this.imp.getVersion(param)
    };

    Monitor.prototype.getServiceStatus=function (param){
        return this.imp.getServiceStatus(param)
    };

    Monitor.prototype.setService=function (param){
        return this.imp.setService(param)
    };

    Monitor.prototype.checkDigest=function (param){
        return this.imp.checkDigest(param)
    };

    Monitor.prototype.updateMoudle=function (param){
        return this.imp.updateMoudle(param)
    };

    Monitor.prototype.checkVersion=function (param){
        return this.imp.checkVersion(param)
    };

    Monitor.prototype.update=function (param){
        return this.imp.update(param)
    };

    Monitor.prototype.checkCom=function (param){
        return this.imp.checkCom(param)
    };

    Monitor.prototype.checkMoudle=function (param){
        return this.imp.checkMoudle(param)
    };

    Monitor.prototype.repairMoudle=function (param){
        return this.imp.repairMoudle(param)
    };

    Monitor.prototype.restartMonitor=function (param){
        return this.imp.restartMonitor(param)
    };

    Monitor.prototype.setValue=function (param){
        return this.imp.setValue(param)
    };

    Monitor.prototype.getValue=function (param){
        return this.imp.getValue(param)
    };

    Monitor.prototype.openBrowser=function (param){
        return this.imp.openBrowser(param)
    };

    Monitor.prototype.showNotification=function (param){
        return this.imp.showNotification(param)
    };

    Monitor.prototype.config=function (param){
        return this.imp.config(param)
    };

    Monitor.prototype.openAssistor=function (param){
        return this.imp.openAssistor(param)
    };

    Monitor.prototype.close=function (){
        return this.imp.close()
    };

    Monitor.prototype.getCertHistory=function (param){
        return this.imp.getCertHistory(param)
    };

    Monitor.prototype.removeCertHistory=function (param){
        return this.imp.removeCertHistory(param)
    };

    Monitor.prototype.getPage=function (param){
        return this.imp.getPage(param)
    };

    Monitor.prototype.setPage=function (param){
        return this.imp.setPage(param)
    };

    Monitor.prototype.p11Call=function (param){
        return this.imp.p11Call(param)
    };

    Monitor.prototype.findProcess=function (param){
        return this.imp.findProcess(param)
    };

    Monitor.prototype.openProcess=function (param){
        return this.imp.openProcess(param)
    };

    Monitor.prototype.requireMoudle=function (param){
        return this.imp.requireMoudle(param)
    };

    Monitor.prototype.getFilePath=function (param){
        return this.imp.getFilePath(param)
    };

    $m.Monitor=Monitor;

})(HebcaMiddleware);
